import { Component, OnInit } from '@angular/core';
import { httpService } from '../components/body.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import QRCode from 'qrcode'
import { PDFDocument, StandardFonts } from 'pdf-lib';

const FileSaver = require('file-saver');
declare var require: any


@Component({
  selector: 'app-datosusuario',
  templateUrl: './datosusuario.component.html',
  styleUrls: ['./datosusuario.component.css']
})
export class DatosusuarioComponent implements OnInit {

  paciente: any;
  fechaNacimiento: string;
  editando: boolean;
  compania: string;
  cargado: boolean = false;
  qrs: any = [];
  imageQr: string;
  muestraLista: boolean = true;
  muestraQr: boolean = false;
  muestraHistorial: boolean = false;
  fichero: any;
  muestraNuevoQr: boolean = false;
  descripcion: string = '';
  loading: boolean = false;
  muestraMenu: Boolean = true;
  fechaini: any;
  fechafin: any;
  nombreDestinatario: String;
  emailDestinatario: String;
  muestraQrCreado: boolean = false;
  muestraMenuQr: boolean = false;
  muestraMenuAlbaran: boolean = false;
  autorizado: boolean = false;
  historiales: any = [];
  pdf: any;
  pdfCargado: boolean = false;
  albaranActual: any;

  constructor( public http: httpService, public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);

   }

  async ngOnInit() {
    this.cargarQr();
  
  }  

  refrescar() {
    this.cargarQr();
  }
 
  verHistorial(qr) {
   /* if (qr.historial.length === 0) {
      this.toastr.info('Este QR aun no ha tenido USO')
    } else {*/
    this.http.getAlbaranesByQr(qr._id).subscribe( albaranes => {
      this.historiales = albaranes.message;
      console.log(this.historiales)
      this.qr(qr._id);
      this.http.qrActual = qr;
      this.muestraLista = false;
      this.muestraHistorial = true;
    })
      
   // }
   
  }

  cargarQr() {
    this.http.getQrs().subscribe( qrs => {
      this.qrs = qrs.message;
      console.log(this.qrs);
      this.cargado = true;
    })
  
    
  }
  
  cancelar() {
    this.http.paginaactual = 'login';
  }

  qr(texto) {
    QRCode.toDataURL(texto)
    .then(url => {
      this.imageQr = url;
      
    })
    .catch(err => {
      console.error(err)
    })
  }

  pulsado(qr) {
    console.log(qr)
    this.http.qrActual = qr;
    this.muestraLista = false;
    this.qr(qr._id);
    this.muestraQr = true;

  }

  activarQr(qr) { 
    let estado = !qr.activado;
    console.log('Estado: ', estado)
    this.http.qrActual = qr;
    let mensaje = (estado) ? 'Sello Digital activado con éxito' : 'Sello Digital desactivado con éxito'
    this.http.updateQr(this.http.qrActual._id, estado).subscribe( qr => {
      if (qr.status === 'ok') {
        this.toastr.success(mensaje, 'Activacion Sello Digital')
        this.cargarQr()
        this.muestraQr = false;
        this.muestraLista = true;
      } else {
        this.toastr.error('Error al Activar / Desactivar Sello Digital', 'Activacion Sello Digital')
      }
    })
    
  }

  async savePdf() {
    let desc = this.albaranActual ? this.albaranActual.descripcion : this.fichero[0].name;
    let estado = this.albaranActual ? this.albaranActual.estado : '';
    FileSaver.saveAs(this.pdf, desc + "_" + estado + ".pdf");
  }  

  async  createPdfEstados(albaran) {
    this.loading = true;
    this.albaranActual = albaran;
    const estado = '/assets/pdf/estados.pdf';
    const pdftoBytesEstado = await fetch(estado).then(res =>
      res.arrayBuffer()
    )

    let link = albaran.entrega.link;

    const pdfbytes = await fetch(link).then(res =>
      res.arrayBuffer()
    )

    const paginas = await PDFDocument.load(pdfbytes);
    const paginacertificado = await PDFDocument.load(pdftoBytesEstado);

    let numpages = paginas.getPageCount();
    let lastpage = numpages - 1;

    const pdfDoc = await PDFDocument.create();
    const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)

    let pages = [];

    for (let i = 0; i < numpages; i++) {
      pages.push(i);
    }

    // console.log(pages)

    let docPages = [];
    let certPages = [];

    docPages = await pdfDoc.copyPages(paginas, pages)
    certPages = await pdfDoc.copyPages(paginacertificado, [0]);

    for (let i = 0; i < numpages; i++) {
      pdfDoc.addPage(docPages[i])
    }

  

    pdfDoc.addPage(certPages[0]); 
    let hojas = pdfDoc.getPages();
    let hojafirma = hojas[numpages];
 
    hojafirma.setFont(helveticaFont);
    hojafirma.setFontSize(12);
    
    let y = hojafirma.getHeight() - 150; // coordenada Y va decreciendo
      
    // DATOS CREACION
      hojafirma.drawText('CREACIÓN ALBARÁN', { x: 20, y: 660, size: 16, lineHeight: 18 });
    // FECHA Y HORA
      hojafirma.drawText('Fecha y Hora: ' + this.fechaToString(1, albaran.creado) + ' ' + this.fechaToString(2, albaran.creado) + ' horas', { x: 40, y: 630});
    // NOMBRE EMPRESA
      hojafirma.drawText('Emitido por: ' + albaran.emisor.nombre, { x: 40, y: 610 });
    // ORGANIZACION
      hojafirma.drawText('Organización: ' + albaran.emisor.organizacion, { x: 40, y: 590 });

    let my = 550;
    if ( albaran.estado !== 'Creado' && albaran.destinatario.email !== '') {
        // DATOS ENVIO
        hojafirma.drawText('ENVÍO ALBARÁN', { x: 20, y: my, size: 16, lineHeight: 18 }); my = my - 30;
        // FECHA Y HORA
        hojafirma.drawText('Fecha y Hora: ' + this.fechaToString(1, albaran.destinatario.fecha) + ' ' + this.fechaToString(2, albaran.destinatario.fecha) + ' horas', { x: 40, y: my }); my = my - 20;
        // NOMBRE DESTINATARIO
        hojafirma.drawText('Destinatario: ' + albaran.destinatario.nombre, { x: 40, y: my }); my = my - 20
        // EMAIL DESTINATARIO
        hojafirma.drawText(albaran.destinatario.email, { x: 110, y: my }); my = my - 40;
    } else {
      hojafirma.drawText('ENVíO ALBARAN', { x: 20, y: my, size: 16, lineHeight: 18  }); my = my - 30;
      hojafirma.drawText('No se ha enviado este albarán por email desde DashBoard Albarán Digital SmartBiometrik.', { x: 40, y: my }); my = my - 40;
    }


    if ( albaran.estado === 'Firmado') {
        // DATOS FIRMA / ENTREGA
        hojafirma.drawText('FIRMA / ENTREGA ALBARÁN', { x: 20, y: my, size: 16, lineHeight: 18 }); my = my - 30;
        // FECHA Y HORA
        hojafirma.drawText('Fecha y Hora: ' + this.fechaToString(1, albaran.entrega.fecha) + ' ' + this.fechaToString(2, albaran.entrega.fecha) + ' horas', { x: 40, y: my }); my = my - 20;
        // NOMBRE EMPRESA
        hojafirma.drawText('Receptor: ' + this.http.qrActual.emisor.nombre, { x: 40, y: my }); my = my -20
        // ORGANIZACION
        hojafirma.drawText('Organización: ' + this.http.qrActual.emisor.organizacion, { x: 40, y: my }); my = my -20
        // NOMBRE AUTORIZADO
        hojafirma.drawText('Autorizado Recogida: ' + this.http.qrActual.destinatario.nombre, { x: 40, y: my }); my = my - 20;
        // EMAIL AUTORIZADO
        hojafirma.drawText(this.http.qrActual.destinatario.email, { x: 160, y: my });
    } else {
        hojafirma.drawText('FIRMA / ENTREGA ALBARÁN', { x: 20, y: my, size: 16, lineHeight: 18 }); my = my - 30;
        hojafirma.drawText('Este Albarán Digital esta pendiente de FIRMA / ENTREGA', { x: 40, y: my }); my = my - 20;
    
    }

    my = my - 40;
    hojafirma.drawText('Datos verificados por SmartBiometrik.', { x: 20, y: my, size: 10 } );
      

    const pdfBytes = await pdfDoc.save();
    let mypdf = new Blob([pdfBytes], { type: 'application/pdf' })
    let blobUrl = URL.createObjectURL(mypdf);
    
  
      this.pdf = blobUrl;
      this.pdfCargado = true;
      this.muestraHistorial = false;
      this.loading = false;
      

  }

  cerrarPdf() {
    this.pdfCargado = false;
    this.muestraHistorial = true;
  }

  fechaToString(tipo, fecha?){
    let dias = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    console.log(fecha);
    let today: Date;
    if (fecha) {
      today = new Date(fecha);
    } else {
      today = new Date(Date.now());
    }

    let dd = today.getDate().toString();
    let mm = (today.getMonth() + 1).toString();
    let hh = today.getHours().toString();
    let nn = today.getMinutes().toString();
    let ss = today.getSeconds().toString();
    let yyyy: String;

    if (Number(hh) < 10) hh = '0' + hh;
    if (Number(nn) < 10) nn = '0' + nn;

    if (Number(mm) < 10) mm = '0' + mm;
    if (Number(dd) < 10) dd = '0' + dd;

    yyyy = today.getFullYear().toString();

    let result = '';

    if (tipo === 0) result = yyyy + '-' + mm + '-' + dd; // Fecha formato ingles
    if (tipo === 1) result = dd + '-' + mm + '-' + yyyy; // Fecha formato español
    if (tipo === 2) result = hh + ':' + nn; // hora formato HH:MM
    if (tipo === 3) result = yyyy + mm + dd + hh + nn + ss; // numero resumen
    if (tipo === 4) result = yyyy + '-' + mm + '-01';
    if (tipo === 5) result = yyyy + '-' + mm + '-' + dias[Number(mm) - 1];
    if (tipo === 6) result = dd + '-' + mm + '-' + yyyy + '  ' + hh + ':' + nn + ' horas.'; // Fecha formato español fecha + hora
    if (tipo === 7) result = dd + '-' + mm + '-' + yyyy + ' a las ' + hh + ':' + nn + ' horas.'; // Fecha formato español fecha + hora

    return result;
  }

  
  autorizarQr(qr) {
    let estado = !qr.autorizado;
    this.http.qrActual = qr;
    let mensaje = (estado) ? 'Sello Digital Autorizado con éxito' : 'Sello Digital Desautorizado con éxito'
    //let autorizado = (estado) ? true : false;
    this.http.updateAutorizacionQr(this.http.qrActual._id, estado).subscribe( qr => {
      if (qr.status === 'ok') {
        this.toastr.success(mensaje, 'Autorización Sello Digital')
        this.cargarQr()
        this.muestraQr = false;
        this.muestraLista = true;
      } else {
        this.toastr.error('Error al Autorizar / Desautorizar Sello Digital', 'Autorización Sello Digital')
      }
    })
    
  }

  fecha(tipo, mfecha) {

    let dias = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    const today = new Date(mfecha);

    let dd = today.getDate().toString();
    let di = today.getDate() - 29;
    let mm = (today.getMonth() + 1).toString();
    let hh = today.getHours().toString();
    let nn = today.getMinutes().toString();
    let ss = today.getSeconds().toString();
    let yyyy: String;


    if (Number(hh) < 10) hh = '0' + hh;
    if (Number(nn) < 10) nn = '0' + nn;

    if (Number(mm) < 10) mm = '0' + mm;
    if (Number(dd) < 10) dd = '0' + dd;

    yyyy = today.getFullYear().toString();

    let fecha = '';

    if (tipo === 0) fecha = yyyy + '-' + mm + '-' + dd; // Fecha formato ingles
    if (tipo === 1) fecha = dd + '-' + mm + '-' + yyyy; // Fecha formato español
    if (tipo === 2) fecha = hh + ':' + nn; // hora formato HH:MM
    if (tipo === 3) fecha = yyyy + mm + dd + hh + nn + ss; // numero resumen
    if (tipo === 4) fecha = yyyy + '-' + mm + '-01';
    if (tipo === 5) fecha = yyyy + '-' + mm + '-' + dias[Number(mm) - 1];
    if (tipo === 6) fecha = dd + '-' + mm + '-' + yyyy + '  ' + hh + ':' + nn + ' horas.'; // Fecha formato español fecha + hora
    if (tipo === 7) fecha = dd + '-' + mm + '-' + yyyy + ' a las ' + hh + ':' + nn + ' horas.'; // Fecha formato español fecha + hora

    return fecha;

  }

  datosaf() {
    if (this.paciente.nombre === '') {
      this.toastr.warning('Debe crear antes el Paciente.','Atención')
    } else {
      this.http.paginaactual = 'datosaf';
    }
    
  }

  docs() {
    if (this.paciente.nombre === '') {
      this.toastr.warning('Debe crear antes el Paciente.','Atención')
    } else {
      this.http.paginaactual = 'docs';
    }
    
  }



 hoy(mfecha) {

    const today = new Date(mfecha);
    let dd = today.getDate().toString();
    let mm = (today.getMonth() + 1).toString();
    let yyyy:string;


    if(today.getDate() < 10) {

        dd = '0'+ dd;
    }

    if (today.getMonth() < 10) {
        mm = '0'+ mm;
    }

    yyyy = today.getFullYear().toString();

    let fecha = yyyy + '-' + mm + '-' + dd;
  
    return  fecha;

}

nuevoQr() {
  if (this.http.esInvitado) {
    this.toastr.error("Esta logueado como invitado. No puede crear Sellos Digitales")
  } else {
      this.muestraLista = false;
      this.muestraNuevoQr = true;
      this.fechaini =  this.hoy(new Date(Date.now()));
      this.fechafin =  this.hoy(new Date(Date.now()));
      console.log(this.fechafin)
      this.nombreDestinatario = '';
      this.emailDestinatario = '';
  }
}

cancelarNuevoQr() {
  this.muestraLista = true;
  this.muestraNuevoQr = false;
}


gestionQr() {
  this.http.paginaactual = 'qrs';
}

cancelarQrCreado() {
  this.muestraMenu = true;
  this.muestraQrCreado = false;
}

crearQr() {
  this.loading = true;
  let body = {
    emisor: this.http.clienteActual._id,
    inicioValidez: this.fechaini,
    finValidez: this.fechafin,
    destinatario: {
      nombre: this.nombreDestinatario.toUpperCase(),
      email: this.emailDestinatario.toLowerCase(),
    },
    estado:'activo',
    activado: true,
    autorizado: this.autorizado
  }

  console.log(body)

  this.http.crearQr(body).subscribe( qr => {
    if (qr.status === 'ok') {
      this.qr(qr.message._id)
      this.sendmail(qr.message, true);
    } else {
      this.http.showAlerta('Error al crear Sello Digital', 'Crear Sello Digital', 'error')
      this.loading = false;
    }
  })
}

sendmail(qr, creado) {
   
      this.loading = true;
      let html = `
        <p>Tu Sello Digital</p>
        <p>Su Sello Digital ha sido generado por: ` + this.http.clienteActual.organizacion +
          ` <br><a href="https://sellodigital.smartbiometrik.com?qr=` + qr._id +
          `  ">Ir a su Sello Digital</a>
          <br><a href="https://sellodigital.smartbiometrik.com?login=` + qr._id +
          `  ">Ver sus Sellos Digitales</a>`   
      let body = {
        mailTo: qr.destinatario.email,
        asunto: 'Envio de su Sello Digital',
        mensaje: html
      }

      console.log(body);

      this.http.sendmail(body).subscribe( email => {
        console.log(email)
        if (email.status === 'ok') {
          this.loading = false;
          let message = creado ? 'Se ha creado su Sello Digital con éxito y se ha mandado por correo al destinatario.' : 'Se ha enviado su Sello Digital con éxito al destinatario'
          this.http.showAlerta(message, 'Sello Digital', 'success')
          this.cargarQr();
          this.muestraLista = true;
          this.muestraNuevoQr = false;
        } else {
          this.loading = false;
          this.toastr.error('Error al enviar email')
        }
      })
   
}

  archivo(fichero) {
    this.http.certificado().subscribe( resp => {
      console.log(resp);
    })
  }

 

  open(fichero) {
    window.open('https://apipruebas.smartbiometrik.com/'  + fichero, '_blank');
  }

  

}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/Angular/Urbanos/src/app/datosusuario/datosusuario.component.ts